import { Howl } from "howler";
import { Sounds } from "../types";

export default class Sound {
  private static sounds: Partial<Record<Sounds, Howl>> = {};

  static preload(sounds: Sounds[] = Object.values(Sounds)) {
    sounds.forEach((sound) => Sound.getHowl(sound));
  }

  static play(sound: Sounds) {
    const howl = Sound.getHowl(sound);

    if (howl.state() === "loaded") {
      howl.play();
    } else {
      howl.once("load", () => howl.play());
      howl.load();
    }
  }

  private static getHowl(sound: Sounds) {
    if (!Sound.sounds[sound]) {
      Sound.sounds[sound] = new Howl({
        src: [`/audio/${sound}`],
        preload: true,
      });
    }

    return Sound.sounds[sound];
  }
}
